<template>
	<div class="small-12 articleFeatureImage flex justify-center animated fadeIn" v-if="policy">
        <picture class="small-12 float-left" :style="featureBackgroundImage"></picture>
    </div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PolicyFeatureImage',

		/*
		**  Set the props
		*/

		props: {

			policy: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			featureBackgroundImage: function() {

				return 'background: url(' + this.policy.links.feature_image + ') no-repeat center/cover;'

			}

		}

	}

</script>